import React, { Component } from "react";
import Loader from "react-loader-spinner";
import auth from "../../components/auth";
import BackDrop from "../../components/Backdrop/Backdrop";
import { url } from "../../components/url";
import "./AddTaxPayer.css";

class AddTaxPayer extends Component {
  state = {
    title: "",
    surname: "",
    first_name: "",
    middle_name: "",
    dob: "1999-01-01",
    email: "",
    phone_number: "",
    city: "",
    lga: "Agatu",
    tax_office: "Central Ward",
    ward: "Egba",
    bvn: "",
    taxOffList: [],
    wardList: [],
    isShowLoader: false,
    displayErrors: false,
    networkLoader: true
  };

  componentDidMount() {
    this.getTaxOffices();
  }

  logout = () => {
    auth.logout(() => {
      localStorage.removeItem("BRHMMobileToken");
    });
    this.props.history.push("/");
  };

  setTitle = val => {
    this.setState({ title: val.target.value });
  };

  setSurname = val => {
    this.setState({ surname: val.target.value });
  };

  setFirstName = val => {
    this.setState({ first_name: val.target.value });
  };

  setMiddleName = val => {
    this.setState({ middle_name: val.target.value });
  };

  setDob = val => {
    this.setState({ dob: val.target.value });
  };
  setBvn = val => {
    this.setState({ bvn: val.target.value });
  };
  setPhoneNumber = val => {
    this.setState({ phone_number: val.target.value });
  };

  setEmail = val => {
    this.setState({ email: val.target.value });
  };

  setCity = val => {
    this.setState({ city: val.target.value });
  };

  setLGA = val => {
    this.setState({ lga: val.target.value }, () => {
      this.getWard();
    });
  };

  setStation = val => {
    this.setState({ tax_office: val.target.value });
  };

  setWard = val => {
    this.setState({ ward: val.target.value });
  };

  showLoader = event => {
    event.preventDefault();
    if (!event.target.checkValidity()) {
      // form is invalid! so we do nothing
      // alert('not valid')
      this.setState({ displayErrors: true });
      return;
    } else {
      this.setState({ displayErrors: false, isShowLoader: true });
      setTimeout(() => {
        this.submitForm();
      }, 1000);
    }
  };

  submitForm = () => {
    let confirm = window.confirm("Are you certain of the details entered?");
    if (confirm === true) {
      this.saveTaxPayerHandler();
    } else {
      this.setState({ isShowLoader: false });
    }
  };

  saveTaxPayerHandler = () => {
    let formData = JSON.stringify({
      name: "addTaxpayer",
      param: {
        title: this.state.title.toUpperCase(),
        surname: this.state.surname.toUpperCase(),
        firstName: this.state.first_name.toUpperCase(),
        middleName: this.state.middle_name.toUpperCase(),
        dob: this.state.dob,
        phone: this.state.phone_number,
        email: this.state.email,
        lga: this.state.lga,
        ward: this.state.ward,
        bvn: this.state.bvn,
        city: this.state.city.toUpperCase(),
        tax_office: this.state.tax_office
      }
    });

    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.BRHMMobileToken
      },
      method: "POST",
      body: formData
    })
      .then(response => response.json())
      .then(res => {
        console.log(res);

        if (res.hasOwnProperty("response") && res.response === true) {
          alert("Tax Payer Has Been Successfully Registered!");
          this.props.history.push("/home");
        } else if (res.hasOwnProperty("error")) {
          alert(res.error.message);
          if (res.error.message === "Expired token") {
            this.logout();
          }
        } else {
          alert(res.response);
        }
      })
      .then(this.setState({ isShowLoader: false }))
      .catch(error => {
        this.setState({ isShowLoader: false });
        if (error + "" === "TypeError: Failed to fetch") {
          alert(
            "Please check if the device is connected to stable cellular data plan or WiFi."
          );
        }
      });
  };

  getTaxOffices = () => {
    let formData = JSON.stringify({
      name: "getTaxOffices",
      param: {}
    });

    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.BRHMMobileToken
      },
      method: "POST",
      body: formData
    })
      .then(response => response.json())
      .then(res => {
        // console.log(res);

        if (res.hasOwnProperty("error")) {
          alert(res.error.message);
          if (res.error.message === "Expired token") {
            this.logout();
          }
        } else {
          this.setState({ taxOffList: res });
        }
      })
      .then(() => this.getWard());
  };

  getWard = () => {
    this.setState({ networkLoader: true });
    let formData = JSON.stringify({
      name: "getWards",
      param: {
        lga: this.state.lga
      }
    });

    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.BRHMMobileToken
      },
      method: "POST",
      body: formData
    })
      .then(response => response.json())
      .then(res => {
        // console.log(res);

        if (res.hasOwnProperty("error")) {
          alert(res.error.message);
          if (res.error.message === "Expired token") {
            this.logout();
          }
        } else {
          this.setState({
            wardList: res.response.result,
            networkLoader: false
          });
        }
      });
  };

  render() {
    const { displayErrors } = this.state;

    const taxOffice = this.state.taxOffList.map((office, i) => {
      return (
        <option key={i} value={office.station_code}>
          {office.station_code}
        </option>
      );
    });

    const ward = this.state.wardList.map((wd, i) => {
      return (
        <option key={i} value={wd.wards}>
          {wd.wards}
        </option>
      );
    });

    let loading = (
      <BackDrop>
        <p>loading...</p>
      </BackDrop>
    );

    return (
      <div>
        {this.state.networkLoader ? loading : null}
        <form
          style={styles.container}
          onSubmit={this.showLoader}
          className={displayErrors ? "displayErrors" : "nodisplayErrors"}
          noValidate
        >
          <input
            type="text"
            placeholder="Title"
            onChange={this.setTitle}
            style={styles.input}
            required
          />

          <input
            type="text"
            placeholder="Surname"
            onChange={this.setSurname}
            style={styles.input}
            required
          />
          <input
            type="text"
            placeholder="First Name"
            onChange={this.setFirstName}
            style={styles.input}
            required
          />
          <input
            type="text"
            placeholder="Middle Name"
            onChange={this.setMiddleName}
            style={styles.input}
          />
          <input
            type="number"
            pattern="\d+"
            placeholder="BVN"
            onChange={this.setBvn}
            style={styles.input}
          />
          <input
            type="email"
            placeholder="Email"
            onChange={this.setEmail}
            style={styles.input}
          />
          <input
            type="number"
            pattern="\d+"
            placeholder="Phone Number"
            onChange={this.setPhoneNumber}
            style={styles.input}
            required
          />
          <input
            type="text"
            placeholder="City"
            onChange={this.setCity}
            style={styles.input}
            required
          />
          <div style={styles.pickerStyle}>
            <label style={styles.label} htmlFor="dob">
              Date of Birth
            </label>

            <input
              id="dob"
              name="dob"
              onChange={this.setDob}
              type="date"
              pattern="\d{2}\/\d{2}/\d{4}"
              data-parse="date"
              style={styles.box}
              placeholder="01/01/1999"
              defaultValue={"1999-01-01"}
              required
            />
          </div>

          <div style={styles.pickerStyle}>
            <p style={styles.label}>LGA of Residence</p>
            <select style={styles.box} onChange={this.setLGA}>
              <option defaultValue value="Agatu">
                Agatu
              </option>
              <option value="Apa">Apa</option>
              <option value="Ado">Ado</option>
              <option value="Buruku">Buruku</option>
              <option value="Gboko">Gboko</option>
              <option value="Guma">Guma</option>
              <option value="Gwer East">Gwer East</option>
              <option value="Gwer West">Gwer West</option>
              <option value="Katsina-Ala">Katsina-Ala</option>
              <option value="Konshisha">Konshisha</option>
              <option value="Kwande">Kwande</option>
              <option value="Logo">Logo</option>
              <option value="Makurdi">Makurdi</option>
              <option value="Obi">Obi</option>
              <option value="Ogbadibo">Ogbadibo</option>
              <option value="Ohimini">Ohimini</option>
              <option value="Oju">Oju</option>
              <option value="Okpokwu">Okpokwu</option>
              <option value="Oturkpo">Oturkpo</option>
              <option value="Tarka">Tarka</option>
              <option value="Ukum">Ukum</option>
              <option value="Ushongo">Ushongo</option>
              <option value="Vandeikya">Vandeikya</option>
            </select>
          </div>

          <div style={styles.pickerStyle}>
            <p style={styles.label}>Tax Office</p>
            <select style={styles.box} onChange={this.setStation}>
              {taxOffice}
            </select>
          </div>

          <div style={styles.pickerStyle}>
            <p style={styles.label}>Ward</p>
            <select style={styles.box} onChange={this.setWard}>
              {ward}
            </select>
          </div>

          {this.state.isShowLoader ? (
            <div style={{ alignSelf: "center", marginTop: 10 }}>
              <Loader type="ThreeDots" color="#8cab49" height="40" width="40" />
            </div>
          ) : (
            <button type="submit" style={styles.button}>
              Save
            </button>
          )}
        </form>
      </div>
    );
  }
}

export default AddTaxPayer;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    marginTop: 10,
    width: "100%",
    maxWidth: "100%",
    alignContent: "center",
    justifyContent: "center",
    alignSelf: "center",
    backgroundColor: "#eee",
    height: "100%"
  },

  pickerStyle: {
    display: "flex",
    paddingTop: 5,
    width: "90%",
    justifyContent: "space-around",
    alignSelf: "center"
  },

  button: {
    marginTop: 20,
    width: "30%",
    height: "40px",
    backgroundColor: "#8cab49",
    borderColor: "transparent",
    color: "white",
    alignSelf: "center",
    outline: "none"
  },

  input: {
    display: "flex",
    borderStyle: "solid",
    borderRadius: 9,
    marginBottom: 4,
    height: 40,
    backgroundColor: "white",
    textDecorationLine: "none",
    outline: "none",
    paddingLeft: 10,
    width: "90%",
    alignSelf: "center"
  },
  label: {
    paddingTop: 7,
    width: "50%"
  },
  box: {
    height: 50,
    outline: "none",
    width: "50%"
  }
};
